// extracted by mini-css-extract-plugin
export var divider = "_se-0";
export var systemMessage = "_se-1";